export default __webpack_public_path__ + "maps-overview-header-image-960-d0da3be3bc236b294b43f1de8f01844e.png";